import React from 'react';
import Collapse from 'react-collapse';

import styles from './nw-react-collapse.module.scss';

/**
 * This component is a wrapper component that includes default expand-collapse animation rules
 * my-nerdwallet should be using this component (not react-collapse, directly)
 * To define your own css themes refer to:
 * https://www.npmjs.com/package/react-collapse#theme--proptypesobjectofproptypesstring
 */
const NwReactCollapse = (props) => (
  <Collapse {...props} theme={{ collapse: styles.NwReactCollapse }} />
);

export default NwReactCollapse;
